<template>
    <transition appear name="fade-transition">
        <span class="display__enum">
            <app-tooltip :value="tooltipValue" :disabled="tooltipDisabled">
                <template v-if="hasType">
                    <app-chip :type="enumTypes[value] || 'grey'" :text="displayValue" />
                </template>
                <template v-else>
                    {{ displayValue }}
                </template>
            </app-tooltip>
        </span>
    </transition>
</template>

<script>
import Display from './Display';

export default {
    name: 'DisplayEnum',
    extends: Display,
    props: {
        enums: {
            type: Object,
            required: true
        },
        enumA11yKey: {
            type: String,
            default: 'enums'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        enumTypes: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        items() {
            return Object.keys(this.enums).map(k => ({
                text: this.$t(`${this.enumA11yKey}.${k}`),
                value: k
            }));
        },
        item() {
            if (this.multiple && Array.isArray(this.value)) {
                return this.value.map(v => this.items.find(i => i.value === v));
            }
            return this.items.find(i => i.value === this.value);
        },
        displayValue() {
            const fallback = this.fallback || '';

            if (this._.isNil(this.value)) {
                return fallback;
            }

            if (this.multiple && Array.isArray(this.item)) {
                if (this.item.length === 0) {
                    return fallback;
                }
                return this.item.map(i => i.text).join(', ');
            }

            return this.item ? this.item.text : fallback;
        },
        hasType() {
            return Object.keys(this.enumTypes).length > 0;
        }
    }
};
</script>

<style lang="scss" scoped>
.display__enum {
    min-width: 7rem;
}
</style>
